import { render, staticRenderFns } from "./TotpEnroll.vue?vue&type=template&id=01370146&scoped=true&"
import script from "./TotpEnroll.vue?vue&type=script&lang=js&"
export * from "./TotpEnroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01370146",
  null
  
)

export default component.exports